
export default class CreateOrUpdateSalesTaxPermitRequestDTO {
    companyId?: number;
    state?: string;
    registrationDate?: Date;
    registrationDocumentId?: number;
}